import usePlacesAutocomplete, { getDetails } from 'use-places-autocomplete';
import './AddressField.scss';
import React, { useEffect } from 'react';

interface Props {
  error: string;
  handleField: (param: any) => void;
  fetchFullDetails?: boolean;
  initialValue?: string;
}

function PlacesAutocomplete({
  error,
  handleField,
  fetchFullDetails,
  initialValue,
}: Props) {
  useEffect(() => {
    if (initialValue !== undefined && initialValue !== value) {
      setValue(initialValue, false);
    }
  }, [initialValue]);

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
      types: ['address'],
    },
    debounce: 300,
    defaultValue: initialValue || '',
  });

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Update the keyword of the input element
    setValue(e.target.value);
  };

  const handleSelect = async (suggestion: {
    place_id: string;
    description: string;
  }) => {
    setValue(suggestion.description, false);
    clearSuggestions();

    if (fetchFullDetails) {
      try {
        const rawDetails = await getDetails({ placeId: suggestion.place_id });

        if (typeof rawDetails !== 'string') {
          const cleanedDetails = {
            address_components: rawDetails?.address_components || [],
            adr_address: rawDetails?.adr_address || '',
            formatted_address: rawDetails?.formatted_address || '',
            geometry: rawDetails?.geometry || {},
          };

          handleField({
            ...suggestion,
            fullDetails: cleanedDetails,
          });
        }
      } catch (err) {
        handleField(suggestion); // fallback to basic
      }
    } else {
      handleField(suggestion);
    }
  };

  const renderSuggestions = () => data.map((suggestion) => {
    // console.log(value.length);

    const {
      place_id: placeId,
      structured_formatting: {
        main_text: mainText,
        secondary_text: secondaryText,
      },
    } = suggestion;

    return (
      <li key={placeId} onClick={() => handleSelect(suggestion)}>
        <small>
          {mainText}
          ,
        </small>
          &nbsp;
        <small>{secondaryText}</small>
      </li>
    );
  });

  return (
    <div className="addressField">
      <label className="addressField-label" htmlFor="address">
        Address
      </label>
      <input
        type="text"
        disabled={!ready}
        value={value}
        onChange={handleInput}
        id="address"
      />
      <div style={{ textAlign: 'right' }}>
        {error && <div className="error">{error}</div>}
      </div>
      {status === 'OK' && <ul>{value.length > 3 && renderSuggestions()}</ul>}
    </div>
  );
}
export default PlacesAutocomplete;
